export default {
    props: {
        value: {
            type: [String, Number, Date, Object, Boolean, File, Array],
            default: ""
        },

        label: {
            type: String,
            default: ""
        },

        labelText: {
            type: String,
            default: ""
        },

        labelClasses: {
            type: String,
            default: ""
        },

        rules: {
            type: [String, Object],
            default: ""
        },

        description: {
            type: String,
            default: ""
        },

        name: {
            type: String,
            default: ""
        },

        placeholder: {
            type: String,
            default: ""
        },

        inputAccept: {
            type: String,
            default: ""
        },

        multiple: {
            type: Boolean,
            default: false
        },

        maxFiles: {
            type: Number,
            default: 8
        },

        options: {
            type: Array,
            default: () => { return [] }
        },
    },
    data() {
        return {
            localValue: this.value
        };
    },
    methods: {
        update() {
            this.$emit("input", this.localValue);
        },

        toggle() {
            this.localValue = !this.localValue;
            this.update();
        },

        updateInverted() {
            this.$emit("input", !this.localValue);
        },
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        }
    }
};
